<script>
import { Scatter } from 'vue-chartjs'
// import the component - chart you need

export default {
  name: 'scatterChart',
  extends: Scatter,
  props: ['data', 'options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.options = {
      scales: {
        yAxes: [{
          display: false,
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 1,
            stepSize: 1
          },
          gridLines: {
            display: false,
            color: 'rgba(0, 0, 0, 0)',
            drawOnChartArea: false
          }
        }],
        xAxes: [{
          ticks: {
            maxTicksLimit: 4,
            scaleFontSize: 40
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
            drawOnChartArea: false
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index]
            var getSalary = Math.round(tooltipItem.xLabel)
            var formatSalary = '$' + getSalary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return label + ' - [' + formatSalary + ']'
          }
        },
        titleMarginBottom: 8,
        bodySpacing: 10,
        xPadding: 10,
        yPadding: 15,
        cornerRadius: 2,
        backgroundColor: 'rgb(255, 255, 255)',
        bodyFontColor: 'rgb(48, 48, 48)',
        bodyFontSize: '18',
        caretPadding: 10,
        displayColors: false
      }
    }
    this.renderChart(this.data, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// widgetSrc/app/programguide/components/ScatterChart.vue